// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap/dist/js/bootstrap.bundle';
// import '../assets/css/style.css';
// import '../assets/js/main';
import { useState } from "react";
import { Link } from "react-router-dom";

function Hero() {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  const handleVideoClick = (event) => {
    event.preventDefault();
    setIsVideoOpen(true);
  };

  const handleCloseVideo = () => {
    setIsVideoOpen(false);
  };

  return (
    <>
      <section id="hero" className="d-flex align-items-center">
        <div className="container position-relative text-center text-lg-start" data-aos="zoom-in" data-aos-delay="100">
          <div className="row">
            <div className="col-lg-8">
              <h1>
                Welcome to <span>2020 Group LLC</span>
              </h1>
              <h2>Providing global solutions!</h2>

              <div className="btns">
                <a href="#services" className="btn-menu animated fadeInUp scrollto">
                  Our Services
                </a>
                <a href="#contact" className="btn-book animated fadeInUp scrollto">
                  Request a Call
                </a>
              </div>
            </div>
            <div className="col-lg-4 d-flex align-items-center justify-content-center position-relative" data-aos="zoom-in" data-aos-delay="200">
              <Link
                to="https://www.youtube.com/watch?v=u6BOC7CDUTQ"
                className="play-btn"
                onClick={handleVideoClick}
              ></Link>
            </div>
          </div>
        </div>
      </section>

      {isVideoOpen && (
        <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{ backgroundColor: "rgba(0,0,0,0.85)", zIndex: 99999 }}>
          <div className="position-relative" style={{ width: "min(90vw, 960px)", aspectRatio: "16 / 9" }}>
            <button
              type="button"
              className="btn-close btn-close-white position-absolute top-0 end-0 m-3"
              aria-label="Close"
              onClick={handleCloseVideo}
              style={{ zIndex: 1 }}
            />
            <iframe
              src="https://www.youtube.com/embed/u6BOC7CDUTQ?autoplay=1"
              title="2020 Group LLC video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-100 h-100 rounded"
              style={{ border: 0 }}
            />
          </div>
        </div>
      )}
    </>
  );
}

export default Hero;